import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import DashboardPage from "./pages/DashboardPage";
import SongMakerPage from "./pages/SongMakerPage";
import RhymesPage from "./pages/RhymesPage";
import CompilerPage from "./pages/CompilerPage";
import ProjectDetailPage from "./pages/ProjectDetailPage";
import "./App.css";

function App() {
  return (
    <div className="App font-body">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<DashboardPage />} />
          <Route path="/songs" element={<SongMakerPage />} />
          <Route path="/rhymes" element={<RhymesPage />} />
          <Route path="/compiler" element={<CompilerPage />} />
          <Route path="/project/:id" element={<ProjectDetailPage />} />
        </Routes>
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;
